/**
 * @generated SignedSource<<eb1a0247806619bb236a14117be0f363>>
 * @relayHash fb0f5bd4e0875b020bca705bacd1c36e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb0f5bd4e0875b020bca705bacd1c36e

import { ConcreteRequest } from 'relay-runtime';
export type useCallTranscriptSubscriptionDeSubscription$variables = {
  appointmentId: string;
};
export type useCallTranscriptSubscriptionDeSubscription$data = {
  readonly de_onCallTranscriptUpdated: {
    readonly callTranscriptEndedAt: string;
    readonly id: string;
    readonly transcript: ReadonlyArray<{
      readonly id: string;
      readonly text: string;
    }>;
  };
};
export type useCallTranscriptSubscriptionDeSubscription = {
  response: useCallTranscriptSubscriptionDeSubscription$data;
  variables: useCallTranscriptSubscriptionDeSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      }
    ],
    "concreteType": "CallTranscript",
    "kind": "LinkedField",
    "name": "de_onCallTranscriptUpdated",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TranscriptEntry",
        "kind": "LinkedField",
        "name": "transcript",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callTranscriptEndedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCallTranscriptSubscriptionDeSubscription",
    "selections": (v2/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCallTranscriptSubscriptionDeSubscription",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "fb0f5bd4e0875b020bca705bacd1c36e",
    "metadata": {},
    "name": "useCallTranscriptSubscriptionDeSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "17aae5c8313d6167e10022a57c5c6746";

export default node;
